import type { ProblemPool } from './deal';

/**
 * Pool/memory helpers shared by the add/sub and mul/div problem-population
 * ports. Both families' problem states structurally satisfy the field
 * subset each helper touches, so they stay in one place rather than drifting
 * as two verbatim copies.
 */

/** The state fields these helpers read or mutate. */
export interface RulesPoolState {
  /** Legacy `topEQs`. */
  topEQs: string[];
  /** Legacy `bottomAnswers`. */
  bottomAnswers: string[];
  /** Legacy `blnFirstTimeLayer`. */
  blnFirstTimeLayer: number[];
}

/** Replaces the state's pool with a copy of a static data-file table. */
export function loadPool(state: RulesPoolState, data: ProblemPool): void {
  state.topEQs = [...data.topEQs];
  state.bottomAnswers = [...data.bottomAnswers];
}

export function isFirstTime(state: RulesPoolState, layer: number): boolean {
  return state.blnFirstTimeLayer[layer - 1] === 1;
}

export function markVisited(state: RulesPoolState, layer: number): void {
  state.blnFirstTimeLayer[layer - 1] = 0;
}

export function zeros(length: number): number[] {
  return new Array<number>(length).fill(0);
}

/**
 * Inclusive-range integer picker over an injected RNG, matching the shape of
 * the `Chance.randomInt(min, max)` the legacy engines used.
 */
export function createRandomInt(
  rng: () => number,
): (min: number, max: number) => number {
  return (min, max) => min + Math.floor(rng() * (max - min + 1));
}
